import { render, staticRenderFns } from "./TransferDestinationCustomer.vue?vue&type=template&id=47aeaf71&"
import script from "./TransferDestinationCustomer.vue?vue&type=script&lang=js&"
export * from "./TransferDestinationCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TransferDestinationCustomer.vue"
export default component.exports